import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createHoliday } from "../redux/actions/holidayActions";
import { fetchDistricts, fetchMunicipalities } from "../redux/actions/locationActions";

const CreateHoliday = () => {
  const [holiday_name, setHolidayName] = useState("");
  const [holiday_date, setHolidayDate] = useState("");
  const [description, setDescription] = useState("");
  const [district_id, setDistrictId] = useState("");
  const [municipality_id, setMunicipalityId] = useState("");

  const dispatch = useDispatch();

  const { creating, error } = useSelector((state) => state.holiday);
  const { districts, municipalities } = useSelector((state) => state.location);

  const filteredMunicipalities = district_id
    ? municipalities.filter((m) => m.district_id === parseInt(district_id))
    : municipalities;

  useEffect(() => {
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!holiday_name || !holiday_date || !description) return;

    dispatch(
      createHoliday(holiday_name, holiday_date, description, district_id, municipality_id)
    );

    setHolidayName("");
    setHolidayDate("");
    setDescription("");
    setDistrictId("");
    setMunicipalityId("");
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Holiday</h1>

        {error && (
          <div className="bg-red-100 text-red-700 border border-red-300 px-4 py-2 rounded mb-4">
            Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* District Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">District (optional)</label>
            <select
              value={district_id}
              onChange={(e) => {
                setDistrictId(e.target.value);
                setMunicipalityId("");
              }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
            >
              <option value="">Select District</option>
              {districts.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </select>
          </div>

          {/* Municipality Dropdown */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Municipality (optional)</label>
            <select
              value={municipality_id}
              onChange={(e) => setMunicipalityId(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
            >
              <option value="">Select Municipality</option>
              {filteredMunicipalities.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.name}
                </option>
              ))}
            </select>
          </div>

          {/* Holiday Name */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Holiday Name</label>
            <input
              type="text"
              value={holiday_name}
              onChange={(e) => setHolidayName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
              placeholder="Enter holiday name"
              required
            />
          </div>

          {/* Holiday Date */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Holiday Date</label>
            <input
              type="date"
              value={holiday_date}
              onChange={(e) => setHolidayDate(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
              required
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
              placeholder="Enter description"
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={creating}
            className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
              creating ? "bg-gray-400 cursor-not-allowed" : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {creating ? "Creating..." : "Create Holiday"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateHoliday;
